// This file is AUTOGENERATED, do not edit it manually!!!

export const menu = {
    activityList: 'Centro de actividades',
    addlicenses: 'Añadir Licencias',
    approvals: 'Solicitudes de Aprobación',
    billingReport: 'Informe de Facturación',
    commonReports: 'Informes Comunes',
    companySettings: 'Configuración de la Empresa',
    customers: 'Clientes',
    customfields: 'Campos Personalizados',
    dashboard: 'Cuadro de mandos',
    forms: 'Formularios personalizados',
    generalOptions: 'Configuración de la Cuenta',
    guestPortal: 'Portal de Invitados',
    logout: 'Cerrar sesión',
    myassignments: 'Mis asignaciones',
    myoptions: 'Mis Ajustes',
    mySettingsNotifications: 'Notificaciones',
    mySettingsOptions: 'Configuración Avanzada',
    mySettingsProfile: 'Perfil',
    myvacations: 'Mis Vacaciones',
    notificationCenter: 'Notificaciones',
    notifications: 'Configuración de las Notificaciones',
    payrollReport: 'Informe de Nómina',
    portfolios: 'Portafolios',
    powerbi: 'Inteligencia de negocios',
    presetsHideViewTooltip: 'Ocultar vista',
    presetsListTitle: 'Guardar vistas',
    ratecards: 'Tarjetas de Tarifas',
    reportgenerator: 'Informe Personalizado',
    reports: 'Informes',
    resourcesPage: 'Recursos',
    roles: 'Roles',
    search: 'Buscar',
    summaryReport: 'Informe de Resumen de Registros de Tiempo',
    support_center: 'Centro de soporte',
    support_chat: 'Chat de soporte',
    systemLists: 'Listas del Sistema',
    timelogs: 'Registros de tiempo',
    updateLicense: 'Actualizar Licencia',
    users: 'Usuarios',
    vacationsreport: 'Vacaciones',
    whatif: 'Simulación de Carga de Recursos',
    workflows: 'Flujos de trabajo',
};
